{
  "version": 1,
  "asset_id": "e8312811-f86b-422a-b776-5e1861fd2153",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e8312811-f86b-422a-b776-5e1861fd2153/dilated-pouch-boxed-es-980.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e8312811-f86b-422a-b776-5e1861fd2153/dilated-pouch-boxed-es-980.jpg",
  "original_filename": "dilated-pouch-boxed-es-980.jpg",
  "size": 146900,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:09:19Z"
}
